import { AdvanceTable } from '@aibees/shared/features';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(AdvanceTable)`
  table {
    td,
    th {
      overflow: hidden;
      text-overflow: hidden;
      white-space: nowrap;
      color: ${(p) => p.theme.palette.common.black};
    }

    tr:last-child td {
      border-bottom: none !important;
    }
  }
  tr {
    background: ${(p) => p.theme.palette.common.white};
    td {
      padding: ${(p) => p.theme.spacing(1)};
    }
  }
  th {
    height: ${(p) => p.theme.spacing(4.2)};
    padding: ${(p) => p.theme.spacing(0, 1)};
  }
  td {
    padding-top: ${(p) => p.theme.spacing(1)};
    padding-bottom: ${(p) => p.theme.spacing(1)};
  }
  .Table {
    background-color: ${(p) => p.theme.palette.common.white};
  }
`;

export const StyledInactiveMember = styled(Box)<{ inactive: boolean }>`
  opacity: ${(p) => (p.inactive ? 0.3 : 'unset')};
`;
